import React, { useEffect, useState } from 'react';
import { fetchTransactions } from '../services/transactions/transactionsService';
import '../styles/transactions.css';

const statusClass = (status) => {
  switch (status) {
    case 'completed':
      return 'badge-completed';
    case 'failed':
      return 'badge-failed';
    case 'error':
      return 'badge-warning';
    default:
      return 'badge-unknown';
  }
};

const Transactions = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    let ignore = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetchTransactions({ pageSize: 25 });
        if (!ignore) {
          setItems(res.items);
          setCursor(res.cursor);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, []);

  const loadMore = async () => {
    if (!cursor) return;
    setLoading(true);
    try {
      const res = await fetchTransactions({ pageSize: 25, cursor });
      setItems((prev) => [...prev, ...res.items]);
      setCursor(res.cursor);
    } finally {
      setLoading(false);
    }
  };

  const filtered = statusFilter === 'all' ? items : items.filter((i) => i.status === statusFilter);

  return (
    <div className="admin-page tx-root">
      <div className="tx-header">
        <h1 className="admin-heading-sm">Manual Payment Transactions</h1>
        <label className="tx-filters">
          <span className="admin-label">Status</span>
          <select
            className="admin-field"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
            <option value="error">Error</option>
          </select>
        </label>
      </div>

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Status</th>
              <th>Gateway</th>
              <th>Source</th>
              <th>Code</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && !loading ? (
              <tr className="data-table-empty-row">
                <td colSpan={9}>No transactions</td>
              </tr>
            ) : (
              filtered.map((t) => (
                <tr key={`${t.id}`}>
                  <td>{t.createdAt ? new Date(t.createdAt).toLocaleString() : '-'}</td>
                  <td>{t.id || '-'}</td>
                  <td>{t.amount ? `$${Number(t.amount).toFixed(2)}` : '-'}</td>
                  <td>{t.currency || '-'}</td>
                  <td>
                    <span className={`badge ${statusClass(t.status)}`}>{t.status || 'unknown'}</span>
                  </td>
                  <td>{t.gateway || '-'}</td>
                  <td>{t.source || '-'}</td>
                  <td>{t.code || '-'}</td>
                  <td className="tx-message">{t.message || '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="tx-footer">
        <button
          type="button"
          className="admin-btn admin-btn-secondary"
          onClick={loadMore}
          disabled={!cursor || loading}
        >
          Load more
        </button>
        {loading ? <span className="admin-muted">Loading…</span> : null}
      </div>
    </div>
  );
};

export default Transactions;
